$.getScript("modules/carreiras/module_carreiras.js");

// general input masks
$('.cepMask').mask("99999-999");
$('.cpfMask').mask("999.999.999-99");
$('.dataMask').mask("99/99/9999");
$('.foneMask').focusout(function () {
    var phone, element;
    element = $(this);
    element.unmask();
    phone = element.val().replace(/\D/g, '');
    if (phone.length > 10) {
        element.mask("(99) 99999-999?9");
    } else {
        element.mask("(99) 9999-9999?9");
    }
}).trigger('focusout');

$('.priceFormat').priceFormat({
    prefix: 'R$ ',
    centsSeparator: ',',
    thousandsSeparator: '.',
    clearOnEmpty: true
});

// components
if ($('.c-tabMenuNav').length) {
    var el = $('.c-tabMenuNav');
    var ellink = $('.c-tabMenuNav .scrolling');
    var scrollEfetuado = 0;
    $(window).on('scroll', function() {
        scrollEfetuado = $(this).scrollTop();
    });
    ellink.on('click', function(event) {
        event.preventDefault();
        var sectionDestiny = $(this).attr('href');
        var sectionDestiny_offsetTop = $(sectionDestiny).offset().top;
        var distanceArticleFromTop = 30;

        // check the top distance of article destiny
        if (scrollEfetuado > sectionDestiny_offsetTop) {
            distanceArticleFromTop = 120}

        // scroll to section
        goToSection__scroll($(sectionDestiny), distanceArticleFromTop, 0, 700, 10);

        // change statement of li
        el.children('li').children('a').removeClass('is-active');
        $(this).addClass('is-active');
    });
}

// pages
if ($('.innerPage').length) {
    var nav = $('nav');
    $(window).on('scroll', function() {
        if (nav.hasClass('defaultNav--hide'))  {
            $('.u-sticky--0').removeClass('u-sticky--90');
        } else {
            $('.u-sticky--0').addClass('u-sticky--90');
        }
    });
}
if ($('#page__faq').length) {
    $('.faq__list li h4').on('click', function (){
        $(this).parent('li').toggleClass('is-active');
    });
    $('.makeQuestion').on('click', function(e) {
        e.preventDefault();
        var finalDestiny = $(this).attr('href');
        goToSection__scroll(finalDestiny, 0, 0, 700, 10);
    });
}
if ($('.l-headerProduto').length) {
    $('.c-linkScrollDown a').on('click', function(e) {
        e.preventDefault();
        var finalDestiny = $(this).attr('href');
        goToSection__scroll(finalDestiny, 0, 0, 700, 10);
    });
}
$(document).on('change','#formContato_estado',function(){
    var uf = $(this).val();
    $("#formContato_cidade").html('<option>Carregando cidades...</option>');
    $.ajax({
        type: "POST",
        data: {uf: uf},
        url: "ajax-cidades.php",
        success: function (result) {
            $("#formContato_cidade").html(result);
        }
    });
});

if ($('#page__contato').length || $('#page__faq').length ) {
    $("#formContato").validate({
        submitHandler: function (form) {
            //SUBMIT form
            $(form).ajaxSubmit({
                //target: 'status-envio',
                beforeSubmit: function () {
                    $('#formContato .c-stsSend').removeClass('u-dnone');
                    $('#formContato .c-stsSend__feedback--load').removeClass('u-dnone');
                    $('#formContato  #btnContato').attr('disabled', true);
                },
                success: function (result) {
                    result = result.split('|');
                    if(parseInt(result[1]) == 1){
                        $('#formContato .c-stsSend__feedback').addClass('u-dnone');
                        $('#formContato .c-stsSend__feedback--success').removeClass('u-dnone');
                        setTimeout(function(){
                            $('#formContato #btnContato').attr('disabled',false);
                            $("#formContato .field").val('');
                            $("#formContato textarea").val('').html('');
                            $("#formContato .field").removeClass('error');
                            $('#formContato .c-stsSend').addClass('u-dnone');
                            $('#formContato .c-stsSend__feedback').addClass('u-dnone');
                        },2000);
                    }else{
                        $('#formContato .c-stsSend__feedback').addClass('u-dnone');
                        $('#formContato .c-stsSend__feedback--error').removeClass('u-dnone');
                        $('#formContato .c-stsSend__feedback--error span').html(result[2]);
                        setTimeout(function () {
                            $('#formContato .c-stsSend').addClass('u-dnone');
                            $('#formContato .c-stsSend__feedback').addClass('u-dnone');
                            $('#formContato #btnContato').attr('disabled', false);
                        }, 3000);
                    }
                }
            });
        }
    });
}

$(document).on('click','.produtosList__moreProducts a',function(){
    var totalRows = $(this).attr('data-rows');
    var page = $(this).attr('data-page');
    var maxRows = $(this).attr('data-max');
    var query = $(this).attr('data-s');
    $.ajax({
        type: "POST",
        data: {totalRows: totalRows,page: page,maxRows: maxRows,query: query},
        url: "ajax-loadProducts.php",
        success: function (result) {
            result = result.split("|");
            if(result[1] === 'S'){
                $(".produtosList__grid").append(result[2]);
                $(".produtosList__moreProducts a").attr('data-page', (parseInt(page) + 1));
            }
            if(parseInt(result[3]) < 1){
                $(".produtosList__moreProducts").hide();
                //console.log(parseInt(result[3]));
            }
        }
    });
});